import { render, staticRenderFns } from "./InstagramPostItemContentsParts.vue?vue&type=template&id=078fdcd4&scoped=true"
import script from "./InstagramPostItemContentsParts.vue?vue&type=script&lang=ts"
export * from "./InstagramPostItemContentsParts.vue?vue&type=script&lang=ts"
import style0 from "./InstagramPostItemContentsParts.vue?vue&type=style&index=0&id=078fdcd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078fdcd4",
  null
  
)

export default component.exports